import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
import { Store } from '@src/store';
import { IRuleStatus } from '@src/interfaces/rule.interfaces';
import { DialogManagerService } from '@src/services';
import moment from 'moment';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { FormControl } from '@angular/forms';
import { CategoryDialogComponent, CategoryDialogData } from '@app/shared/components/dialogs';

@Component({
    selector: 'rule-item',
    template: require('./rule-item.component.html'),
    styles: [require('./rule-item.component.scss')]
})
export class RuleItemComponent implements OnInit, OnDestroy {
    public toppings = new FormControl();
    public toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

    @Input() public processData: any;
    @Input() public rules: any;
    @Input() public indexInList: any;
    @Input() public get rule() {
        return this._rule;
    }

    public set rule(rule) {
        this._rule = rule;
    }
    // tslint:disable-next-line:variable-name
    private _rule: any;

    @Output() public onDuplicate = new EventEmitter<any>();
    @Output() public onDelete = new EventEmitter<any>();
    @Output() public onSaveRule = new EventEmitter<void>();
    @Output() public onCancel = new EventEmitter<void>();

    // public ruleFirstNameIsValid: any;
    private currentSelectionIdx: any;
    public passingTest: IRuleStatus;
    public wrongMatchedTest: IRuleStatus;
    public wrongValidTest: IRuleStatus;
    public currentSelection: any;
    private translations: any;

    constructor(private store: Store,
                private dialogManagerService: DialogManagerService,
                private translatePipe: TranslatePipe) {
        this.translatePipe.transform(['ERROR', 'ERROR_NO_CATEGORY_ENTERED']).then(value => this.translations = value);
        this.currentSelection = null;
        this.currentSelectionIdx = 0;
        this.passingTest = { type: 'success', msg: 'Regex Matched the Test.' };
        this.wrongMatchedTest = { type: 'danger', msg: 'Regex Not Matched the Test.' };
        this.wrongValidTest = { type: 'danger', msg: 'Regex Not Valid for run the Test.' };
        // this.statusTest = null;
    }

    public ngOnInit() {
    }

    public ngOnDestroy(): void {
        this.store.dispatch({ type: policyEngineActions.CLEAR_PREVIOUS_STATE, payload: { policies_rule_data: null } });
    }

    public openRegexpCheckerDialog(expression, isSensitive) {
        const onEdit = ({ expression, caseSensitive }) => {
            this.changeExpression(expression, caseSensitive);
        };
        const dialogData = { expression, caseSensitive: isSensitive };
        this.dialogManagerService.showRegexpCheckerDialog(dialogData, onEdit);
    }

    public changeExpression(expression, caseSensitive) {
        this._rule.expression = expression;
        this._rule.isSensitive = caseSensitive;
        this.dialogManagerService.showSuccessDialog({ title: 'Regular expression was successfully updated', text: '' });
    }

    public onTimeChangeCallback(values) {
        const { timeValue, timeType } = values;
        this._rule[timeType] = timeValue;
    }

    public onChangeRuleType(item): void {
        this._rule.TimingMode = item.value.Key === 1;
    }

    public onChangeName(): void {
        if (this.rule.isNew) {
            this.rules[this.currentSelectionIdx].name = this.rule.name;
        }
    }

    public onNewCategory() {
        const onConfirm = (data:CategoryDialogData) => {
            if (data.category.Value !== '') {
                this._rule.CategorySelection = data.category;
                this.processData.MetaData.Rules.Categories.push(data.category);
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['ERROR_NO_CATEGORY_ENTERED']
                });
            }
        };
        const dialogData = { title: 'Add Category', text: 'Category Name', category: { Value: '', Key: 0 } };
        this.dialogManagerService.showDialog(dialogData, onConfirm, CategoryDialogComponent, 'add-category-dialog');
    }

    public convertFormat(date: string) {
        const types = { day: 'numeric', month: 'numeric', year: 'numeric' };
        const dd = moment.utc(date, 'DD/MM/YYYY').local().toDate().toLocaleString([], types);
        return dd ? dd.split(',')[0] : date;
    }

    public selectDay(day: string, value: any): void {
        this.rule.Days[day] = value.checked ? 1 : 0;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/rules-management/rule-item/rule-item.component.ts